import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { NotificationService, Toast } from '../../services/notification.service';
import { NotificationType } from '../../models/notification';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts = signal<Toast[]>([]);
  private sub!: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.sub = this.notificationService.toasts$.subscribe(toast => {
      this.toasts.update(list => [...list, toast]);
      setTimeout(() => this.dismiss(toast.id), toast.duration);
    });
  }

  dismiss(id: number) {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  iconFor(type: NotificationType): string {
    return { success: 'check_circle', error: 'error', warning: 'warning', info: 'info' }[type] ?? 'info';
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
